import React, { Component } from 'react';
import ReactExport from "react-data-export";
import store from '../../store';
import ReporteOperacionalO from './ReporteOperacionalO';
import ReporteOperacionalE from './ReporteOperacionalE';

class ReportNew extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.ocultarMenu = this.ocultarMenu.bind(this);
    }

    ocultarMenu() {
        store.dispatch({
            type: 'STATE_MOSTRAR',
            mostrar: 'noMostrar'
        });
    }

    render() {
        return (
            <div className="container mt-4" onClick={this.ocultarMenu}>
                <div className="row">
                    <div className="col-12">
                        <ul className="nav nav-tabs m-bottom flex-column flex-md-row justify-content-end" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active show" id="unidades-tab" data-toggle="tab" href="#unidades" role="tab"
                                    aria-controls="unidades" aria-selected="true">&nbsp;&nbsp;&nbsp;Operacion</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="asignacion-tab" data-toggle="tab" href="#asignacion" role="tab" aria-controls="asignacion"
                                    aria-selected="false">&nbsp;&nbsp;&nbsp;Entrenamiento</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade active show" id="unidades" role="tabpanel" aria-labelledby="unidades-tab">
                        <ReporteOperacionalO />
                    </div>
                    <div className="tab-pane fade" id="asignacion" role="tabpanel" aria-labelledby="asignacion-tab">
                        <ReporteOperacionalE />
                    </div>
                </div>
            </div>
        );
    }
}

export default ReportNew;


// WEBPACK FOOTER //
// ./src/Components/Reportes/ReporteNew.js